import { styled } from "styled-components";
import { Link } from "react-router-dom";
import { MdOutlineArrowOutward } from "react-icons/md";

import HomeContainerWrapper from "../../components/HomeContainerWrapper";
import HomeHeading from "../../components/HomeHeading";
import projects from "../../assets/docs/projects.json";
import Projects from "./Projects";

export default function index() {
  return (
    <Container id="projects">
      <HomeContainerWrapper>
        <HomeHeading>Go-Getter Projects</HomeHeading>
        <Projects len={3} />
        {projects.length > 3 && (
          <LoadMore to="/projects">
            Load more <MdOutlineArrowOutward />
          </LoadMore>
        )}
      </HomeContainerWrapper>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  margin-top: 100px;

  @media (max-width: 768px) {
    margin-top: 30px;
  }
`;

const LoadMore = styled(Link)`
  font-family: "Poppins", sans-serif;
  text-decoration: none;
  cursor: pointer;
  margin: 20px auto;
  color: #abababff;
  background: none;
  border-radius: 25px;
  padding: 16px 40px;
  font-size: 15px;
  transition: all 0.2s ease-out;
  border: 1px solid #abababff;
  font-weight: 400;

  svg {
    transform: translate(10px, 1px) scale(1.1);
  }

  &:hover {
    color: #000;
    background: #fff;
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 12px;
  }
`;
